module.exports = __webpack_public_path__ + "static/media/CursoCompleto.0d77027c.png";